import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import Layout from '../layout/Layout';
import { getUser } from '../../service/AccountService';

const canAccess = (roles = []) => {
  const { roleId } = getUser();
  return (
    roles.some(x => x === roleId)
  );
};

export default ({
  component: C,
  props: cProps,
  roles,
  companyTypes,
  ...rest
}) => {
  if (!localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)) {
    return (
      <Route
        {...rest}
        render={props => (
          <Redirect
            to={`/login?redirect=${props.location.pathname}${
              props.location.search
            }`}
          />
        )}
      />
    );
  }

  if (true) {
    return (
      <Route
        {...rest}
        render={props => {
          return (
            <Layout {...props} {...cProps}>
              <C {...props} {...cProps} />
            </Layout>
          );
        }}
      />
    );
  }

  return <Route {...rest} render={props => <Redirect to={`/forbiden`} />} />;
};



// WEBPACK FOOTER //
// ./src/shared/component/route/AuthenticatedRoute.js